import Layout from "@/components/layout";
import sourceflowEnums from "@/sourceflow.enums";
import { SourceFlowHeadDefault } from "@sourceflow-uk/sourceflow-head";
import SourceFlowTracker from "@sourceflow-uk/sourceflow-tracker";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import metaObject from "../.sourceflow/metadata.json";
import "../styles/styles.scss";

/**
 *
 * @param Component
 * @param pageProps
 * @returns {JSX.Element}
 * @constructor
 */
export default function App({ Component, pageProps }) {
  const safeMetaObject = { ...metaObject };
  if (safeMetaObject["/components/"]) {
    delete safeMetaObject["/components/"];
  }

  return (
    <Layout>
      <SourceFlowHeadDefault
        metaObject={safeMetaObject}
        siteName={sourceflowEnums.seo.siteName}
        titleTemplate={sourceflowEnums.seo.titleTemplate}
        images={sourceflowEnums.seo.images}
        twitter={sourceflowEnums.seo.twitter}
      />
      <Component {...pageProps} />
      <SourceFlowTracker />
      {/* <GoogleAnalytics gaId="G-JKQPS8LCP5" /> */}
      {/* <CookieConsent>
				 <GoogleAnalytics gaId="JKQPS8LCP5" />
				<GoogleTagManager gtmId="CUSTOMER_GMT_ID" />
			</CookieConsent> */}
    </Layout>
  );
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-tracker
